import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fail-warn",
  "use": "fail-warn-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 56\" id=\"fail-warn\"><path d=\"M28 0C12.537 0 0 12.537 0 28c0 15.462 12.537 28 28 28 15.462 0 28-12.538 28-28C56 12.537 43.462 0 28 0Zm-2 14.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5v17c0 .275-.225.5-.5.5h-3a.501.501 0 0 1-.5-.5v-17ZM28 42a3 3 0 0 1 0-6 3 3 0 0 1 0 6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol